import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import { lighten, makeStyles } from '@material-ui/core/styles'
import theme from 'material/theme'

import { useAppSelector } from 'store'

import { PremiumWrapper } from '../components/PremiumPreview/PremiumWrapper'
import { HighschoolResults } from './useGetHighschoolPreviewData'

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableCell-root': {
      border: `1px solid ${theme.palette.divider}`,
    },
    '& .MuiTableCell-head': {
      width: 'calc(100% / 3)',
    },
  },
  highlightedRow: {
    backgroundColor: lighten(theme.palette.info.light, 0.8),
  },
}))

const CellData = ({ data }: { data?: number }) => {
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )
  const formattedData = data !== undefined && data !== null ? data : '—'
  return (
    <Box>
      {isPremiumExplorerEnabled ? (
        formattedData
      ) : (
        <FontAwesomeIcon
          icon={faLock}
          color={theme.palette.text.disabled}
        />
      )}
    </Box>
  )
}

const StudentEngagementDetails = ({
  studentEngagement = [],
  currentSeniorYear,
}: {
  studentEngagement: HighschoolResults['studentEngagement']
  currentSeniorYear: number
}) => {
  const classes = useStyles()
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )

  const sortedStudentEngagement = [...studentEngagement].sort((a, b) => {
    if (a.year < b.year) {
      return 1
    }
    if (a.year > b.year) {
      return -1
    }
    return 0
  })

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="h6">Scoir Engagement</Typography>
      <PremiumWrapper
        enabled={isPremiumExplorerEnabled}
        trackingIdPlacement="student-engagement-details"
      >
        <Table
          className={classes.table}
          aria-label="Student Engagement table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Class Year</TableCell>
              <TableCell>Inquiries</TableCell>
              <TableCell>Applicants</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(isPremiumExplorerEnabled ? sortedStudentEngagement : fakeEngagement(currentSeniorYear)).map(
              (engagement) => (
                <TableRow
                  key={engagement.year}
                  className={engagement.year === currentSeniorYear ? classes.highlightedRow : undefined}
                >
                  <TableCell>{engagement.year}</TableCell>
                  <TableCell>
                    <CellData data={engagement.numInterested} />
                  </TableCell>
                  <TableCell>
                    <CellData data={engagement.numApplicants} />
                  </TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </PremiumWrapper>
    </Box>
  )
}

export default StudentEngagementDetails

function fakeEngagement(currentSeniorYear: number) {
  return [
    currentSeniorYear + 3,
    currentSeniorYear + 2,
    currentSeniorYear + 1,
    currentSeniorYear,
    currentSeniorYear - 1,
    currentSeniorYear - 2,
    currentSeniorYear - 3,
  ].reduce(
    (acc, year) => {
      acc.push({
        year,
        numInterested: 0,
        numApplicants: 0,
      })
      return acc
    },
    [] as { year: number; numInterested: number; numApplicants: number }[],
  )
}
